import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const SITE = process.env.REACT_APP_PUBLIC_SITE_URL;
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("fo_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const skip = ["/auth/refresh", "/auth/login", "/auth/register"].some((u) => (cfg.url || "").includes(u));
    if (err.response?.status === 401 && !cfg._retry && !skip && localStorage.getItem("fo_token")) {
      cfg._retry = true;
      try {
        const { data } = await api.post("/auth/refresh");
        localStorage.setItem("fo_token", data.token);
        return api(cfg);
      } catch {
        localStorage.removeItem("fo_token");
      }
    }
    return Promise.reject(err);
  }
);

export const media = (u) => (!u ? null : u.startsWith("/api") ? BASE + u : u);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function deviceId() {
  let id = localStorage.getItem("fo_device");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Math.random()).slice(2);
    localStorage.setItem("fo_device", id);
  }
  return id;
}

export const fmtTime = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
export const fmtDate = (iso) => new Date(iso).toLocaleDateString([], { day: "2-digit", month: "short", year: "numeric" });
export const pad = (n) => String(n).padStart(2, "0");
export const GENRES = ["pop", "indie", "rap", "electronic", "rock", "r&b", "jazz", "folk", "metal", "other"];
export const ROLES = [["singer", "Singer"], ["band", "Band"], ["producer", "Producer"]];
export const REACTIONS = ["voice", "beat", "hook", "lyrics", "vibe"];

export const streamText = async (path, body, onChunk) => {
  const res = await fetch(`${BASE}/api${path}`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("fo_token")}` }, body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || "AI draft failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  for (;;) { const { done, value } = await reader.read(); if (done) break; onChunk(dec.decode(value, { stream: true })); }
};
